import PropTypes from 'prop-types'

import { Columns } from '@domain-group/suit-theme'

import { digObject, generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useProvider'
import usePublication, { useRelations } from '@hooks/usePublication'

import LinkToEntityModule from '@components/LinkToEntityModule'

import TemplatePageList from '@components/TemplatePageList'
import PageLayout from '../../../../components/PageLayout'

import Agencies from '../Agencies'
import BrandGroups from '../BrandGroups'
import CompatiblePaginations from '../CompatiblePaginations'
import PublicationEditions from '../PublicationEditions'
import PublicationOptions from '../PublicationOptions'
import PublicationPaginationRules from '../PublicationPaginationRules'
import PublicationProducts from '../PublicationProducts'
import PublicationTools from '../../../../components/PublicationTools'
import SpecialDeadlines from '../SpecialDeadlines'

const PageContent = (props) => {
  const { publicationId } = props

  const publicationPayload = usePublication({ id: publicationId })
  const {
    loading,
    publication,
  } = publicationPayload

  const { provider } = useRelations(publication)
  const {
    logo: providerLogo,
    short_name: providerShortName,
    title: providerTitle,
  } = provider

  const { editProviderUrl } = generateUrls(provider)

  const providerImageUrl = digObject(providerLogo, 'thumb', '')

  return (
    <PageLayout entityPayload={publicationPayload} activeTabBarItemKey="relations">
      <Columns.Main>
        <Agencies publicationId={publicationId} />

        <BrandGroups publicationId={publicationId} />

        <PublicationEditions publicationId={publicationId} />

        <PublicationOptions publicationId={publicationId} />

        <PublicationProducts publicationId={publicationId} />

        <TemplatePageList
          allowedFilters={['agency_id', 'brand_id', 'service_product_id']}
          filterIds={{ publication_id: publicationId }}
        />

        <PublicationPaginationRules publicationId={publicationId} />

        <SpecialDeadlines publicationId={publicationId} />
      </Columns.Main>

      <Columns.Sidebar>
        <LinkToEntityModule
          entityTitle={providerTitle}
          goToHref={`${editProviderUrl}?redirect=${generateRedirectUrl()}`}
          imageUrl={providerImageUrl}
          loading={loading}
          moduleTitle="Provider"
          secondaryText={providerShortName}
        />

        <PublicationTools publicationPayload={publicationPayload} />

        <CompatiblePaginations publicationId={publicationId} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

PageContent.propTypes = {
  publicationId: PropTypes.number.isRequired,
}

export default PageContent
